import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ActionCardConfigInterface } from '@brightside/brightside-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BrightsideUiModule } from 'libs/brightside-ui/src/lib/brightside-ui.module';
import { routePath } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-promotion-contest-card',
    imports: [BrightsideUiModule, TranslateModule],
    templateUrl: './promotion-contest-card.component.html',
    styleUrl: './promotion-contest-card.component.scss',
    animations: [
        trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('500ms ease-out', style({ opacity: 1 }))])]),
    ]
})
export class PromotionContestCardComponent implements OnInit {
  promotionContestActionCard: ActionCardConfigInterface;

  private _translateService: TranslateService = inject(TranslateService);
  private _router: Router = inject(Router);

  ngOnInit(): void {
    this.promotionContestActionCard = {
      title: this._translateService.instant('PROMOTION_CONTEST_TITLE'),
      image: '../assets/promotion-contest-banner.png',
      body: this._translateService.instant('PROMOTION_CONTEST_DESC'),
      cardStyle: 'large',
      ctaString: this._translateService.instant('PROMOTION_CONTEST_CTA'),
      marginBottom: 'small',
    };
  }

  onCtaClicked(): void {
    this._router.navigate([routePath('contest')]);
  }
}
